var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-expand-manual" }, [
    _c("p", { staticClass: "wkb-expand-manual-intro" }, [
      _vm._v(
        " Search for a specific node and add it to the graph with its connecting edges. "
      ),
    ]),
    _c("label", { staticClass: "wkb-expand-manual-field" }, [
      _c("span", { staticClass: "wkb-expand-manual-label" }, [_vm._v("Type")]),
      _c(
        "select",
        {
          staticClass: "wkb-expand-manual-select",
          attrs: { disabled: _vm.busy },
          domProps: { value: _vm.entityType },
          on: { change: _vm.onEntityTypeChange },
        },
        _vm._l(_vm.entityTypeOptions, function (option) {
          return _c(
            "option",
            { key: option.value, domProps: { value: option.value } },
            [_vm._v(" " + _vm._s(option.label) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("label", { staticClass: "wkb-expand-manual-field" }, [
      _c("span", { staticClass: "wkb-expand-manual-label" }, [
        _vm._v("Search"),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        staticClass: "wkb-expand-manual-input",
        attrs: {
          type: "text",
          placeholder: _vm.searchPlaceholder,
          disabled: _vm.busy,
          "aria-label": _vm.searchPlaceholder,
        },
        domProps: { value: _vm.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.query = $event.target.value
          },
        },
      }),
    ]),
    _vm.searchLoading
      ? _c(
          "p",
          {
            staticClass: "wkb-expand-manual-status",
            attrs: { role: "status" },
          },
          [_vm._v("Searching…")]
        )
      : _vm.geneSetSearchUnavailableNote
      ? _c("p", { staticClass: "wkb-expand-manual-note" }, [
          _vm._v(" " + _vm._s(_vm.geneSetSearchUnavailableNote) + " "),
        ])
      : _vm._e(),
    _vm.conceptualSearchEnabled
      ? _c(
          "button",
          {
            staticClass: "wkb-expand-manual-link",
            attrs: {
              type: "button",
              disabled: _vm.busy || _vm.semanticLoading || !_vm.query.trim(),
            },
            on: { click: _vm.runSemanticMatch },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.semanticLoading
                    ? "Finding conceptual matches…"
                    : "+ Add conceptual matches"
                ) +
                " "
            ),
          ]
        )
      : _vm._e(),
    _vm.catalogSuggestions.length
      ? _c(
          "ul",
          { staticClass: "wkb-expand-manual-suggestions" },
          _vm._l(_vm.catalogSuggestions, function (item, index) {
            return _c(
              "li",
              { key: _vm.entityKey(item) || `catalog-${index}` },
              [
                _c(
                  "button",
                  {
                    staticClass: "wkb-expand-manual-suggestion",
                    class: { "is-added": _vm.isAlreadyOnGraph(item) },
                    attrs: {
                      type: "button",
                      disabled: _vm.busy,
                      "aria-disabled": _vm.isAlreadyOnGraph(item),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addItem(item)
                      },
                    },
                  },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.displayLabel(item)))]),
                    _vm.subtitleFor(item)
                      ? _c(
                          "span",
                          { staticClass: "wkb-expand-manual-suggestion-sub" },
                          [_vm._v(" " + _vm._s(_vm.subtitleFor(item)) + " ")]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm.semanticMatches.length
      ? _c(
          "div",
          { staticClass: "wkb-expand-manual-semantic" },
          [
            _c("p", { staticClass: "wkb-expand-manual-semantic-title" }, [
              _vm._v("Conceptual matches"),
            ]),
            _vm._l(_vm.semanticMatches, function (item, index) {
              return _c(
                "button",
                {
                  key: _vm.entityKey(item.candidate) || `semantic-${index}`,
                  staticClass: "wkb-expand-manual-suggestion",
                  class: { "is-added": _vm.isAlreadyOnGraph(item.candidate) },
                  attrs: {
                    type: "button",
                    disabled: _vm.busy,
                    "aria-disabled": _vm.isAlreadyOnGraph(item.candidate),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addItem(item.candidate)
                    },
                  },
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.displayLabel(item.candidate))),
                  ]),
                  _vm.subtitleFor(item.candidate)
                    ? _c(
                        "span",
                        { staticClass: "wkb-expand-manual-suggestion-sub" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.subtitleFor(item.candidate)) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  item.rationale
                    ? _c(
                        "span",
                        { staticClass: "wkb-expand-manual-suggestion-sub" },
                        [_vm._v(" " + _vm._s(item.rationale) + " ")]
                      )
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        )
      : _vm._e(),
    !_vm.llmAvailable &&
    _vm.entityType !== "gene_set" &&
    _vm.entityType !== "gene"
      ? _c("p", { staticClass: "wkb-expand-manual-note" }, [
          _vm._v(" Conceptual matching requires an LLM backend. "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }